import {
  ISearchFieldConfig,
  SearchFieldType,
} from "../../../../components/advanced-search/AdvancedSearch.interface";

export const preRegistrationSearchConfig: ISearchFieldConfig[] = [
  {
    type: SearchFieldType.DROPDOWN,
    label: "Status",
    key: "status",
    dropdownValues: [
      { label: "All", value: "" },
      { label: "Pending", value: "pending" },
      { label: "Registered", value: "registered" },
      { label: "Claimed", value: "claimed" },
    ],
  },
  {
    type: SearchFieldType.DATE_RANGE,
    label: "Created date",
    key: "from",
    rangeEndKey: "to",
    placeholder: "From",
    rangeEndPlaceholder: "To",
  },
];
